module.exports = __webpack_public_path__ + "static/media/Heaven_Main.91365d05.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Heaven_Main.webp
// module id = ./src/assets/Heaven_Main.webp
// module chunks = 0